<template>
  <div class="listView-wrapper">
    <div class="res-content-wrapper">
      <ion-grid class="loc-search">
        <ion-row>
          <ion-col size-md="11" size-xs="12">
            <div class="loc-wrpaper">
              <span class="rp-desktop">Location:</span>
              <span class="rp-mobile">
                <img src="/assets/images/common/search/116836@2x.png" class="lense-icon" />
              </span>
              <input type="text" id="pac-input" v-model="locationAdd" placeholder="Enter Location" />
              <img src="../../assets/locate.svg" class="map-marker-icon" v-on:click="getLocation" />
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
    <div class="card-list-wrapper">
      <div>
        <div class="card-list" v-for="(item, index) in masterData" :key="index">
          <ion-grid>
            <ion-row>
              <ion-col size-md="6" size-xs="12">
                <div class="card-list-content">
                  <p class="ion-no-margin title">{{item.name}}<span v-if="item.rating != 0">&nbsp;{{item.rating}}&nbsp;<ion-icon class="star-rating" :icon="star"></ion-icon></span></p>
                  <p class="ion-no-margin loc">
                    {{item.address.line1}},
                    {{item.address.city}}
                  </p>
                  <p class="ion-no-margin time">Open: {{item.opensAt}} - {{item.closesAt}}</p>
                  <p class="ion-no-margin rp-mobile distance-sec-mbl">{{item.distance.description}}</p>
                </div>
              </ion-col>
              <ion-col size-md="6" size-xs="12">
                <div class="card-list-booking">
                  <p class="ion-no-margin rp-desktop">{{item.distance.description}}</p>
                  <div class="call-options">
                    <a v-bind:href="'tel:'+ item.mobile" class="call-img-a">
                      <img class="call-img" src="../../assets/card-call.png" />
                    </a>
                    <img
                      @click="googleMapApp(item)"
                      class="map-img"
                      src="../../assets/card-map.png"
                    />

                    <ion-button
                      class="book-btn"
                      v-if="item.status.id == 'A'"
                      @click="bookNow(item)"
                      expand="block"
                      shape="round"
                    >Next</ion-button>

                    <ion-button
                      class="book-btn"
                      v-if="item.status.id != 'A'"
                      disabled
                      @click="bookNow(item)"
                      expand="block"
                      shape="round"
                    >Next</ion-button>
                  </div>
                </div>
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>
      </div>
      <div class="spinnerWrapper">
        <ion-spinner v-if="loaderTab"></ion-spinner>
      </div>
      <div class="card-list" v-if="noDataBoolean">
        <ion-grid>
          <ion-row>
            <ion-col size-md="12" size-xs="12">
              <p class="noData">No Station Found</p>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonGrid, IonRow, IonCol, IonButton, IonSpinner } from "@ionic/vue";

import { Coordiate } from "@/entity/location/corodinate";
import { EVCStationService } from "@/service/evcstation/stations.service";
import { LocalStorage } from "../../data/localstorage";
import { ConfigurationService } from "../../service/configuration";
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";
import { ToastUtils } from "../../util/toast-utils";
import { star } from "ionicons/icons"

export default defineComponent ({
  name: 'reservationListView',
  components: {
    IonGrid, IonRow, IonCol, IonButton, IonSpinner
  },
  data() {
    return {
      star,
      locationAdd: "",
      teleUrl: "",
      selectedMarker: [],
      masterData: [],
      currentLoc: {},
      noDataBoolean: false,
      loaderTab: true,
      chargerTypesSelectedValue: null,
      chargerOutputSelectedValue: null,
      chargerPortSelectedValue: null,
      configData: null
    }
  },
  mounted() {
    var input = document.getElementById("pac-input");
    //this.getLocation();
    this.autoCompleteFormation(input, this);
    this.config();
  },
  methods: {
    filterCall() {
      let loadFilter = new EVCStationService()
        .recentlySelectedFilterCriteriaForUser(new LocalStorage().user)
        .then(loadFilterdata => {
          this.chargerTypesSelectedValue = loadFilterdata.chargerType;
          this.chargerOutputSelectedValue = loadFilterdata.outputType;
          this.chargerPortSelectedValue = loadFilterdata.portType;
          this.serviceCall();
        }).catch((error) => {
            let serviceError = migratedTryParseServiceError(error);
            new ToastUtils().presentToast(serviceError.description);
        });
    },
    autoCompleteFormation(input, thisValue) {
      try {
        var autocomplete = new google.maps.places.Autocomplete(input);
        var geocoder = new google.maps.Geocoder();
        autocomplete.setFields([
          "address_components",
          "geometry",
          "icon",
          "name"
        ]);

        autocomplete.addListener("place_changed", function() {
          var place = autocomplete.getPlace();
          if (!place.geometry) {
            window.alert("No details available for input: '" + place.name + "'");
            return;
          }
          thisValue.currentLoc = {
            latitude: place.geometry.location.lat(),
            longitude: place.geometry.location.lng(),
            type: "current"
          };
          localStorage.setItem("currentLoc", JSON.stringify(thisValue.currentLoc));
          var pos = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
          };
          geocoder.geocode({ location: pos }, (results, status) => {
            thisValue.locationAdd = results[0].formatted_address;

            localStorage.setItem("Autocomplete", thisValue.locationAdd);
          });
          thisValue.filterCall();
        });
      } catch(error) {
          let serviceError = migratedTryParseServiceError(error);
          new ToastUtils().presentToast(serviceError.description);
      }
      
    },
    async config() {
      await new ConfigurationService().configuration().then(data => {
        this.configData = data;
        this.listViegetLocation();
      }).catch((error) => {
          let serviceError = migratedTryParseServiceError(error);
          new ToastUtils().presentToast(serviceError.description);
      });;
    },
    serviceCall() {
      this.markerCoordinates = [];
      new EVCStationService()
        .stationsAroundLocationForUser(
          new Coordiate((this.currentLoc ? this.currentLoc.latitude : 0), (this.currentLoc ? this.currentLoc.longitude : 0)),
          new LocalStorage().user,
          {
            chargerType: this.chargerTypesSelectedValue,
            outputType: this.chargerOutputSelectedValue,
            portType: this.chargerPortSelectedValue,
            radius: Number(this.configData.stationSearchRadius),
            viewType: "LIST"
          }
        )
        .then(data => {
          this.loaderTab = false;
          this.noDataBoolean = false;
          this.masterData = data;
          if (this.masterData.length == 0) {
            this.noDataBoolean = true;
          }
          this.masterData.map(data => {
            var hoursOfOperations = data.hoursOfOperations;
            var d = new Date();
            var n = d.getDay();
            if (d.getDay() == 0) {
              n = 6;
            } else if (d.getDay() == 1) {
              n = 0;
            } else {
              n = n - 1;
            }
            var selectedDate = hoursOfOperations[n];
            var opensAt = selectedDate.opensAt;
            var closesAt = selectedDate.closesAt;
            data["opensAt"] = opensAt;
            data["closesAt"] = closesAt;
          });
        }).catch((error) => {
            let serviceError = migratedTryParseServiceError(error);
            new ToastUtils().presentToast(serviceError.description);
        });
    },
    bookNow(item) {
      localStorage.setItem("teleUrl", "tel:" + item.mobile);
      localStorage.setItem("selectedMarker", JSON.stringify(item));
      localStorage.setItem("opensAt", item.opensAt);
      localStorage.setItem("closesAt", item.closesAt);
      this.$router.push({ name: "bookNow" });
    },
    googleMapApp(item) {
      if (
        /* if we're on iOS, open in Apple Maps */
        navigator.platform.indexOf("iPhone") != -1 ||
        navigator.platform.indexOf("iPod") != -1 ||
        navigator.platform.indexOf("iPad") != -1
      )
        window.open(
          "maps://maps.google.com/maps?daddr=" +
            item.coordinate.latitude +
            "," +
            item.coordinate.longitude +
            "&amp;ll="
        );
      /* else use Google */ else
        window.open(
          "https://maps.google.com/maps?daddr=" +
            item.coordinate.latitude +
            "," +
            item.coordinate.longitude +
            "&amp;ll="
        );
    },
    formatDate(date) {
      var d = new Date(date);
      var hh = d.getHours();
      var m = d.getMinutes();
      var s = d.getSeconds();
      var dd = "AM";
      var h = hh;
      if (h >= 12) {
        h = hh - 12;
        dd = "PM";
      }
      if (h == 0) {
        h = 12;
      }
      m = m < 10 ? "0" + m : m;
      s = s < 10 ? "0" + s : s;
      var pattern = new RegExp("0?" + hh + ":" + m + ":" + s);
      var replacement = h + ":" + m;
      replacement += " " + dd;
      return replacement;
    },
    getLocation() {
      var geocoder = new google.maps.Geocoder();
      navigator.geolocation.getCurrentPosition(
        position => {
          var pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          this.currentLoc = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          };
          localStorage.setItem("currentLoc", JSON.stringify(this.currentLoc));
          geocoder.geocode({ location: pos }, (results, status) => {
            this.locationAdd = results[0].formatted_address;

            localStorage.setItem("Autocomplete", this.locationAdd);
          });
          this.filterCall();
        },
        error => {
          switch (error.code) {
            case error.PERMISSION_DENIED:
              console.log("User denied the request for Geolocation.");
              break;
            case error.POSITION_UNAVAILABLE:
              console.log("Location information is unavailable.");
              break;
            case error.TIMEOUT:
              console.log("The request to get user location timed out.");
              break;
            case error.UNKNOWN_ERROR:
              console.log("An unknown error occurred.");
              break;
          }
        }
      );
    },
    listViegetLocation() {
      this.currentLoc = JSON.parse(localStorage.getItem("currentLoc"));
      this.locationAdd = localStorage.getItem("Autocomplete");
      this.filterCall();
    }
  }
})
</script>

<style scoped>
#pac-input:focus,
.res-content-wrapper .loc-search input:focus {
  padding: 12px;
  margin: 0;
}
.noData {
  text-align: center;
  font-size: 20px;
  margin-top: 28px;
}
.listView-wrapper {
  width: 100%;
  background: #f4f5f9 0% 0% no-repeat padding-box;
}
.spinnerWrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.card-list {
  margin-bottom: 19px;
}

.res-content-wrapper {
  top: 0;
  width: 100%;

  padding: 11px;
}
@media screen and (min-width: 992px) {
  .res-content-wrapper {
    position: absolute;
  }
}
.res-content-wrapper .loc-search input {
  height: 52px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #0000001a;
  border-radius: 12px;
  opacity: 1;
  width: 100%;
  padding: 12px;
  padding-left: 98px !important;
  font-size: 14px;
  text-align: left;
  padding-left: 24px;
  font-family: "Roboto";
  letter-spacing: 0;
  color: #9e9d9d;
}

.loc-wrpaper span {
  height: 17px;
  text-align: left;
  font-size: 14px;
  position: absolute;
  font-family: "Roboto";
  letter-spacing: 0;
  top: 18px;
  padding-left: 18px;
  color: #404040;
  opacity: 1;
}

.loc-wrpaper img,
.loc-wrpaper span {
  z-index: 99;
}

.loc-wrpaper {
  position: relative;
}

.loc-wrpaper img.map-marker-icon {
  position: absolute;
  right: 12px;
  top: 17px;
  cursor: pointer;
}

.res-content-wrapper .loc-search img.map-marker-icon {
  width: 18px;
  height: 18px;
  opacity: 1;
  cursor: pointer;
}

.card-list-content p.title {
  text-align: left;
  font-size: 16px;
  font-family: "Roboto Medium";
  letter-spacing: 0;
  color: #313131;
  opacity: 1;
  margin-bottom: 8px;
}

.card-list-content p.time {
  font-family: "Roboto Light";
}

.card-list-content p.loc,
.card-list-content p.time {
  text-align: left;
  margin-bottom: 8px;
  font-size: 15px;
  letter-spacing: 0;
  color: #313131;
  opacity: 0.75;
}

.card-list-booking p {
  height: 17px;
  text-align: right;
  margin-right: 8px;
  font-size: 14px;
  font-family: "Roboto";
  letter-spacing: 0;
  color: #d66c6c;
  opacity: 1;
}

.card-list-booking {
  text-align: right;
}

.call-options .book-btn {
  width: 115px;
  --background: #21b24b !important;
  border-radius: 36px;
  opacity: 1;
  text-align: left;
  font-size: 16px;
  font-family: "Roboto Medium";
  letter-spacing: 0;
  color: #ffffff;
  display: inline-block;
  position: relative;
  top: -15px;
}

.call-options {
  margin-top: 16px;
}

.call-options img.call-img {
  width: 24px;
  height: 24px;
  position: relative;
  top: -3px;
}
.call-options a.call-img-a {
  margin-right: 21px;
}

.call-options img.map-img {
  width: 36px;
  height: 36px;
  margin-right: 29px;
  cursor: pointer;
}

.card-list-content p.loc {
  font-family: "Roboto";
}

.card-list-wrapper {
  bottom: 100px;
  width: 100%;
  padding: 0 16px;
  padding-top: 15px;
  padding-bottom: 60px;
  padding-bottom: calc(constant(safe-area-inset-bottom) + 60px);
  padding-bottom: calc(env(safe-area-inset-bottom) + 60px);
}

.card-list {
  height: 131px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 16px;
  opacity: 1;
  padding: 16px;
}

@media (max-width: 768px) {
  .card-list {
    height: 190px;
  }
  .lense-icon {
    position: absolute;
  }
  .res-content-wrapper .loc-search {
    background: #fff;
    padding: 9px;
  }
  .res-content-wrapper .loc-search input {
    padding-left: 50px !important;
    text-overflow: ellipsis;
    padding-right: 56px;
  }
  .card-list-wrapper {
    padding: 0px 14px;
    padding-top: 14px;
    padding-bottom: 60px;
    padding-bottom: calc(constant(safe-area-inset-bottom) + 60px);
    padding-bottom: calc(env(safe-area-inset-bottom) + 60px);
  }

  .card-list-booking {
    text-align: left !important;
    position: absolute;
    width: 100%;
    top: -36px;
  }

  .call-options {
    margin-top: 34px;
  }

  .call-options .book-btn {
    position: absolute;
    top: 27px;
    right: 0px;
  }

  .card-list-booking p {
    position: relative;
    top: 6px;
  }

  .distance-sec {
    position: absolute;
    top: 4px;
    right: 0;
    height: 17px;
    text-align: right;
    margin-right: 8px;
    font-size: 14px;
    font-family: "Roboto";
    letter-spacing: 0;
    color: #d66c6c;
    opacity: 1;
  }

  .distance-sec-mbl {
    right: 0;
    height: 17px;
    text-align: right;
    margin-right: 8px;
    font-size: 14px;
    font-family: "Roboto";
    letter-spacing: 0;
    color: #d66c6c;
    opacity: 1;
  }

  .res-content-wrapper {
    padding: 0px !important;
  }
}
</style>